import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

function Sidebar() {
  const navItems = [
    { path: '/bookings', label: 'Bookings', icon: '📅' },
    { path: '/salons', label: 'Salons', icon: '✂️' },
    { path: '/customers', label: 'Customers', icon: '👥' },
    { path: '/settlements', label: 'Advance Settlements', icon: '💳' },
    { path: '/cities', label: 'Cities', icon: '🏙️' },
    { path: '/master-catalog', label: 'Master Catalog', icon: '📚' },
    { path: '/service-requests', label: 'Service Update Request', icon: '📝' },
    { path: '/notifications', label: 'App notifications', icon: '🔔' },
    { path: '/whatsapp-events', label: 'WhatsApp Events', icon: '💬' },
    { path: '/settings', label: 'Settings/Offers', icon: '⚙️' }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Ulloor Styles</h2>
        <p>Admin Dashboard</p>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `sidebar-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;

